import styled from "styled-components";
import logoTM from "../../assets/logo-TM.svg";
import logoVM from "../../assets/logo-vm.svg";
import logoTMmobile from "../../assets/logo-TM-mobile.svg";
import arrowBack from "../../assets/arrow-left.svg";

export const Container = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "withoutLogo",
})`
	background-repeat: no-repeat;
	width: 50%;
	height: 100%;
	background-image: url(${logoTM});
	background-position: center;
	background-color: #13141b;
	display: flex;

	@media only screen and (max-width: 900px) {
		align-items: center;
		width: 100%;
		max-width: 23rem;
		height: ${(props) => (props.withoutLogo ? "3rem" : "10rem")};
		background-image: ${(props) => (props.withoutLogo ? "none" : `url(${logoTMmobile})`)};
	}

	@media only screen and (max-width: 380px) {
		width: 85%;
		min-height: ${(props) => (props.withoutLogo ? "3rem" : "5rem")};
		height: ${(props) => (props.withoutLogo ? "unset" : "7rem")};
	}

	svg {
		width: auto;
	}
`;

export const ContainerButton = styled.div`
	@media only screen and (min-width: 900px) {
		position: fixed;
		margin: 1.5rem;
		height: 2rem;
	}
`;

export const GoBack = styled.button`
	background-color: transparent;
	background-repeat: no-repeat;
	background-image: url(${arrowBack});
	border: none;
	cursor: pointer;
	overflow: hidden;
	outline: none !important;
	color: #01e59b;
	font-size: 16px;
	font-family: "MetropolisRegular";
	width: 4rem;
	line-height: 14px;

	span {
		padding-left: 1rem;
	}
`;

export const LogoVM = styled.div`
	background-image: url(${logoVM});
	background-repeat: no-repeat;
	height: 95%;
	background-position: bottom;
	width: 100%;

	@media only screen and (max-device-width: 900px) {
		background-image: none;
	}
`;
